import { css } from "lit";
import { Style } from "../Styles";

export const styles = css`
    ${Style}
    :host {
        display: block;
    }

    .container {
        border-radius: 0.6em;
        height: 100%;
    }

    .body {
        height: 100%;
        flex-direction: column;
        display: flex;
        overflow: auto;
    }

    .list-header {
        justify-content: space-between;
        align-items: center;
        padding: 0.5em;
    }

    .entry {
        width: 100%;
        justify-content: space-between;
        padding: 1em;
        align-items: center;
        border-top: #ccc 1px solid;
    }

    h3 {
        margin: 0;
    }

    .loading {
        width: 100%;
        height: 30em;
        justify-content: center;
        align-items: center;
    }

    .footer {
        flex-wrap: wrap;
        justify-content: space-evenly;
        padding-top: 0.5rem;
    }

    .footer sl-button {
        flex-grow: 1;
    }

    .checked {
        color: grey;
        text-decoration: line-through;
    }

    .actions {
        display: flex;
        gap: 0.5em;
    }

    ds-search-bar {
        width: 100%;
        padding: 0.5em;
    }

    ds-fixed-panel {
        height: 100%;
    }
`;
